/**
 * Legal directory and footer chrome (policy bodies are English-only in legal/content/).
 */
export const legal = {
  directoryTitle: 'Legal Policies',
  directorySubtitle: 'Terms, privacy, and other legal documents for Adieuu.',
  tableOfContents: 'Table of contents',
  highContrast: 'High Contrast',
  viewAllPolicies: 'View All Policies',
  thirdPartyTitle: 'Third-Party Licenses',
  thirdPartyDescription: 'Open-source components in this build and the terms they are used under.',
  thirdPartySubtitle:
    'Every third-party package included in this build, with its version, license and where to obtain its source.',
  thirdPartyUnavailable:
    'These notices are generated when the app is built, so they are not available in a development build.',
  agreementNotice:
    'By using Adieuu, you agree to our <tosLink>Terms of Service</tosLink> and <privacyLink>Privacy Policy</privacyLink>.',
};

export const footer = {
  copyright: '© {{year}} Adieuu, LLC. All rights reserved.',
};
